<div *ngIf="data">
  <div class="row" *ngFor="let ediOrder of data; index as i; trackBy: trackByFn">
    <div class="col-12 card-body">
      <div class="card-title">
        <h5 class="d-inline cursor-pointer">
          <a [routerLink]="ediOrder.id">
            <i class="fas fa-eye pr-1" style="font-size: larger"></i>
            {{ ediOrder.documentReferences.buyerOrder.id }}
            <span *ngIf="!!ediOrder.erpIds">- {{ ediOrder.erpIds }}</span> -
            <span *ngIf="!!ediOrder.extra?.deliveryCustomer?.name">{{ ediOrder.extra.deliveryCustomer.name }}</span> -
            <otto-olsen-edi-send-status [message]="ediOrder"></otto-olsen-edi-send-status>
          </a>
        </h5>
      </div>

      <div class="row row-cols-2 row-cols-sm-4 row-cols-md-7">
        <div class="col">
          <lib-gung-text-input
            renderStatic="true"
            gungTranslate="ORDER_TYPE"
            [(ngModel)]="ediOrder.orderType"
            class="label-bold"
          ></lib-gung-text-input>
        </div>
        <div class="col">
          <lib-gung-text-input
            renderStatic="true"
            gungTranslate="ORDER_ID"
            [(ngModel)]="ediOrder.documentReferences.supplierOrder.id"
            class="label-bold"
          ></lib-gung-text-input>
        </div>
        <div class="col">
          <lib-gung-text-input
            renderStatic="true"
            gungTranslate="BUYER_ORDER_ID"
            [(ngModel)]="ediOrder.documentReferences.buyerOrder.id"
            class="label-bold"
          ></lib-gung-text-input>
        </div>
        <div class="col">
          <lib-gung-text-input
            renderStatic="true"
            gungTranslate="CONFIG"
            [(ngModel)]="ediOrder.ediConfigId"
            class="label-bold"
          ></lib-gung-text-input>
        </div>
        <div class="col">
          <lib-gung-text-input
            renderStatic="true"
            gungTranslate="BUYER_GLN"
            [(ngModel)]="ediOrder.buyerGln"
            class="label-bold"
          ></lib-gung-text-input>
        </div>
        <div class="col">
          <lib-gung-text-input
            renderStatic="true"
            gungTranslate="VALIDATION"
            [(ngModel)]="ediOrder.validationState"
            class="label-bold"
          ></lib-gung-text-input>
        </div>
        <div class="col">
          <lib-action-btn [(item)]="data[i]" [config]="actionConfigService"></lib-action-btn>
        </div>
      </div>
    </div>
  </div>
</div>